import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NbToastrService } from '@nebular/theme';
import { XeroAuthService } from 'src/app/shared/services/xero-auth.service';
import { FeatureFlagService } from 'src/app/shared/services/feature-flag.service';

@Component({
  selector: 'app-xero-auto-redirect',
  template: `
    <div class="d-flex justify-content-center align-items-center" style="height: 100vh">
      <nb-card>
        <nb-card-body>
          <h4 class="text-center">Xero Sign In</h4>
          <div [nbSpinner]="isLoading" style="width: 100%; height: 50px; background-color: unset"></div>
          <p class="text-center" *ngIf="!errorMessage">Redirecting to Xero</p>
          <div *ngIf="errorMessage" class="text-center">
            <p class="text-danger">{{ errorMessage }}</p>
            <button nbButton status="primary" (click)="retrySignIn()">Try Again</button>
          </div>
        </nb-card-body>
      </nb-card>
    </div>
  `,
})
export class XeroAutoRedirectComponent implements OnInit {
  isLoading = true;
  errorMessage = '';
  private redirectUrl: string = null;

  constructor(
    private xeroAuth: XeroAuthService,
    private router: Router,
    private route: ActivatedRoute,
    private toastrService: NbToastrService,
    private featureFlag: FeatureFlagService,
  ) {}

  async ngOnInit() {
    // Check if Xero auth is enabled
    const isXeroAuthEnabled = await this.featureFlag.isEnabled('xeroAuthEnabled');

    if (!isXeroAuthEnabled) {
      this.handleError('Xero authentication is currently disabled');
      return;
    }

    // Get optional redirect URL from query params
    this.redirectUrl = this.route.snapshot.queryParams['redirect'] || null;

    // Store redirect URL in session storage if provided
    if (this.redirectUrl) {
      sessionStorage.setItem('xeroAuthRedirectUrl', this.redirectUrl);
    }

    // Initiate Xero sign-in
    await this.initiateXeroSignIn();
  }

  async initiateXeroSignIn() {
    try {
      this.isLoading = true;
      this.errorMessage = '';

      await this.xeroAuth.initiateXeroSignIn();
      // Browser will redirect, no code after this will execute
    } catch (error) {
      this.handleError(error?.message || 'An error occurred while connecting to Xero');
    }
  }

  async retrySignIn() {
    await this.initiateXeroSignIn();
  }

  goToLogin() {
    this.router.navigate(['/auth/login']);
  }

  private handleError(message: string) {
    this.isLoading = false;
    this.errorMessage = message;
    this.toastrService.danger(message, 'Authentication Error');
  }
}
